import type { ComponentProps } from 'react';

const HomeCross = (props: ComponentProps<'svg'>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="16"
      viewBox="0 0 20 16"
      fill="none"
      {...props}
    >
      <g clip-path="url(#clip0_989_38469)">
        <path
          d="M8.5157 0.178125C8.79695 -0.059375 9.20633 -0.059375 9.48758 0.178125L16.4407 6.08125C16.1344 6.02813 15.8188 6 15.5001 6C15.0563 6 14.622 6.05312 14.2095 6.15312L9.00008 1.73438L3.50007 6.4V13.5C3.50007 14.0531 3.94695 14.5 4.50007 14.5H10.8907C11.2751 15.0875 11.7657 15.5969 12.3376 16H4.50007C3.11882 16 2.00007 14.8813 2.00007 13.5V7.67188L1.23445 8.32187C0.918825 8.59062 0.443825 8.55 0.1782 8.23438C-0.0874251 7.91875 -0.0499251 7.44375 0.2657 7.17812L8.5157 0.178125ZM10.0001 8H11.2563C10.7782 8.57812 10.4157 9.25625 10.2063 10H10.0001V11.5C10.0001 11.775 9.77507 12 9.50008 12H8.50008C8.22508 12 8.00007 11.775 8.00007 11.5V10H6.50007C6.22507 10 6.00007 9.775 6.00007 9.5V8.5C6.00007 8.225 6.22507 8 6.50007 8H8.00007V6.5C8.00007 6.225 8.22508 6 8.50008 6H9.50008C9.77507 6 10.0001 6.225 10.0001 6.5V8ZM15.5001 7C16.6936 7 17.8381 7.47411 18.6821 8.31802C19.526 9.16193 20.0001 10.3065 20.0001 11.5C20.0001 12.6935 19.526 13.8381 18.6821 14.682C17.8381 15.5259 16.6936 16 15.5001 16C14.3066 16 13.162 15.5259 12.3181 14.682C11.4742 13.8381 11.0001 12.6935 11.0001 11.5C11.0001 10.3065 11.4742 9.16193 12.3181 8.31802C13.162 7.47411 14.3066 7 15.5001 7ZM16.2063 11.5L17.3532 10.3531C17.5469 10.1594 17.5469 9.84063 17.3532 9.64688C17.1594 9.45312 16.8407 9.45312 16.6469 9.64688L15.5001 10.7937L14.3532 9.64688C14.1594 9.45312 13.8407 9.45312 13.647 9.64688C13.4532 9.84063 13.4532 10.1594 13.647 10.3531L14.7938 11.5L13.647 12.6469C13.4532 12.8406 13.4532 13.1594 13.647 13.3531C13.8407 13.5469 14.1594 13.5469 14.3532 13.3531L15.5001 12.2063L16.6469 13.3531C16.8407 13.5469 17.1594 13.5469 17.3532 13.3531C17.5469 13.1594 17.5469 12.8406 17.3532 12.6469L16.2063 11.5Z"
          fill="#63707F"
        />
      </g>
      <defs>
        <clipPath id="clip0_989_38469">
          <rect width="20" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default HomeCross;
